// for pop up size guide only
let size_guide_loaded = false
$(".size_guide-link").click(function(){
  if (size_guide_loaded == false){
    $('#size_guide').addClass("open")
    console.log('modal component',$('#size_guide.popup__overlay'))
    // change content only when dynamic-size-chart class nv existed
    // console.log("size_guide pop",$('#size_guide.popup__overlay:not(.dynamic-size-chart)'))
    var size_guide_url = ''
    size_guide_url = $('#size_guide.popup__overlay:not(.dynamic-size-chart) .popup__content').html().replace(/ /g, '')
    
    // console.log('is white space',/^\s*$/.test(size_guide_url))
    $('#size_guide.popup__overlay .popup__content').html('')
    if (size_guide_url != '' && !(/^\s*$/.test(size_guide_url))){
      console.log('get page content')
      $.ajax({
        url: size_guide_url,
        type: "GET",
        dataType: "html",
        success: function(pageResponse){
          let pageContent = ''
          for (e of $(pageResponse)){
            if (e.id == 'MainContent'){
              pageContent = e
              break
            }
          }
          // let pageContent = $(pageResponse).find("main");
          // console.log('pageContent',pageContent)
          // $("#SalesPoint .modal__centered-content").removeClass("modal-loading")

          $("#size_guide.popup__overlay .popup__content").html(pageContent);
          size_guide_loaded = true
          
        }
      })
    }
    
  }
});

// toggle active classes

function closePopup(element){
  console.log('modal id', element.getAttribute('data-modal-id'))
  console.log('modal element',$("#"+element.getAttribute('data-modal-id')))
  $("#"+element.getAttribute('data-modal-id')).removeClass("open")
  // console.log('modal',$("#"+element.getAttribute('data-modal-id')))
}
